import './footer.css';
export default function Footer() {
  return (
    <div className="footer">
        <p>All rights reserved by Pallab Roy</p>
    </div>
  );
}
